import type { TabDataItem } from '~/common/components/navigation/bars/CSPlatformTabBar';

/** Query param that holds the selected tab for URL-driven tab bars. */
export const TAB_QUERY_PARAM = 'tab';

/**
 * Validates and returns a tab key if it exists in the provided tab data.
 * Returns null if the value is invalid or not found.
 */
export function getValidTab<T extends Record<string, TabDataItem>>(
  value: string | null,
  tabs: T
): Extract<keyof T, string> | null {
  if (!value) return null;

  const matchedKey = Object.keys(tabs).find(
    (key) => key === value.toLowerCase()
  );

  return (matchedKey as Extract<keyof T, string>) ?? null;
}
